import React, { JSX } from 'react';

import ChiliPiperLoader from '../elements/ChiliPiperLoader';
import HubspotForm from '../elements/HubspotForm';

type HubspotProps = {
    formId: string;
    loadingID: string;
    includeChiliPiper?: boolean;
    routerName?: string;
};

/**
 * This component also exists in shared-components. The two should be kept in sync
 * until shared-components goes away.
 */
export default function Hubspot({
    formId,
    loadingID,
    includeChiliPiper = false,
    routerName = 'inbound-router',
}: HubspotProps): JSX.Element {
    return (
        <>
            <HubspotForm formId={formId} loadingID={loadingID} />
            {includeChiliPiper && <ChiliPiperLoader formID={formId} routerName={routerName} />}
        </>
    );
}
